import { NormalModal, logout, jsLoadAnim, loginSession } from "../common/common.js";
import { stripePublicKey } from "../../stripe/setup-intent.js";

// 非ログイン状態であればログインフォームにリダイレクト
(async () => {
    const isLogin = await loginSession();
    if (!isLogin) {
        window.location.replace('/login/index.html');
    }
})();

document.addEventListener('DOMContentLoaded',()=>{
    userInfoFetch();
    loadCartData();
    getCustomerCard();
    document.getElementById('user_info_edit_btn').addEventListener('click',userInfoEditModal);

    setTimeout(()=>{
        const isPC = !/iPhone|iPad|Android|Mobile/i.test(navigator.userAgent);
        if (isPC) {
            alert('PCから購入は可能ですが、使用にはスマートフォンからアクセスする必要があります。');
        }
    },1000)
})

document.getElementById('order').addEventListener('click',()=>{
    new NormalModal('購入を確定します。よろしいですか？', '確定',()=>{
        purchaseFinalize();
    })
})

// ユーザー情報編集
async function userInfoFetch(){
    const response = await fetch('/system/user/cart/detaild-address-fetch.php');
    const data = await response.json();
    if(data.success){
        const item = document.createElement('div');
        item.classList.add('item');
        item.innerHTML = `
            <p>氏名：${data['name']}</p>
            <p>住所：〒${data['postalCode']}<br>${data['todouhuken']} ${data['city']} ${data['street']} ${data['building']}</p>
            <p>電話：${data['tel']}</p>
            <p>メール：${data['email']}</p>
        `;
        document.getElementById('user_info_item_wrap').appendChild(item);
    }else{
        alert(data.message);
    }
}

async function loadCartData() {
    try {
        const response = await fetch('/system/user/cart/cart-session-fetch.php',{
            method:'POST',
        });
        const data = await response.json();

        domcreate(data.cart);

    } catch (error) {
        console.error('エラーが発生しました:', error);
        alert('エラーが発生しました。再試行してください。');
    }
}

async function purchaseFinalize(){
    const animTarget = document.getElementById('detaile');
    try {
        const formData = new FormData();
        const paymentMethod = document.querySelector('input[name="payment_method"]:checked')?.value;
        if(paymentMethod){
            jsLoadAnim(animTarget);
            // DB送信
            const req = await fetch('/system/user/cart/purchase-process.php',{
                method:'POST',
                body: formData
            });
            const res = await req.json();
            if(!res.success){
                alert(res.message);
                if(res.type == "notlogin"){
                    logout();
                }else{
                    window.location.href = '/';
                }
            }

            // 決済送信
            if(paymentMethod == 'paypay'){
                const stripe = Stripe(stripePublicKey);
                const response = await fetch('/system/user/cart/payment-paypay-process.php');
                const result = await response.json();
                if (!result.success) {
                    alert(result.message);
                    return;
                }

                const returnUrl = window.location.origin + '/cart/payment_wait.html';
                const { error } = await stripe.confirmPayment({
                    clientSecret: result.clientSecret,
                    confirmParams: {
                        payment_method_data: {
                            type: 'paypay'
                        },
                        return_url: returnUrl
                    }
                });
                if (error) {
                    alert(error.message);
                    window.location.href = '/';
                }
            }else{
                const paymentReq = await fetch('/system/user/cart/payment-card-process.php',{
                    method:'POST',
                    headers:{'Content-Type':'application/json'},
                    body: JSON.stringify({'paymentMethod':paymentMethod})
                });
                const paymentRes = await paymentReq.json();
                if(paymentRes.success){
                    window.location.href = '/cart/complete.html';
                }else{
                    alert(paymentRes.message);
                    window.location.href = '/';
                }
            }
        }else{
            alert('支払い方法が指定されていません。')
            return false;
        }
    } catch (error) {
        alert('エラーが発生しました。');
        console.error(error);
        window.location.href = '/cart/';
    }
}


function domcreate(json) {
    const arr = JSON.parse(json);
    document.getElementById('item_count').innerText = arr.length;
    
    let resultPrice = 0;
    const cartWrap = document.getElementById('cart_item_wrap');
    cartWrap.innerHTML = '';
    
    arr.forEach(data => {
        resultPrice += data.totalPrice;

        const orderSummary = Object.entries(data.orderSummary)
        .map(([key, value]) => {
            return `
            <div>
                <span>${key}</span>
                <span class="num">個数 ${value.num} / </span>
                <span class="cell-price">単価 ${Number(value.unitPrice).toLocaleString()}円 / </span>
                <span class="cell-result">合計 ${value.unitResult.toLocaleString()}円</span>
            </div>
            `;
        })
        .join('');

        const item = document.createElement('div');
        item.classList.add('item');
        item.dataset.pi = data.pi;
        item.innerHTML = `
            <p class="location">${data.ticketLocation}</p>
            <p class="item_name">${data.ticketName}</p>
            <div class="breakdown">
                <div><span>数量</span></div>
                ${orderSummary}
            </div>
            <div class="option">
                <p class="item_price">小計 ${data.totalPrice.toLocaleString()} 円</p>
            </div>
        `;
        
        cartWrap.appendChild(item);
    });

    document.getElementById('price').innerText = resultPrice;
}

async function userInfoEditModal(){
    const response = await fetch('/system/user/cart/detaild-address-fetch.php');
    const result = await response.json();
    
    const formItems = `
        <ul>
            <li>
                <label for="name">氏名：</label>
                <input type="text" id="name" name="name" value="${result['name']}">
            </li>
            <li>
                <label for="postal_code">郵便番号：</label>
                <input type="text" id="postal_code" name="postal_code" value="${result['postalCode']}">
            </li>
            <li>
                <label for="todouhuken">都道府県：</label>
                <input type="text" id="todouhuken" name="todouhuken" value="${result['todouhuken']}">
            </li>
            <li>
                <label for="city">市町村区：</label>
                <input type="text" id="city" name="city" value="${result['city']}">
            </li>
            <li>
                <label for="street">番地：</label>
                <input type="text" id="street" name="street" value="${result['street']}">
            </li>
            <li>
                <label for="building">建物名：</label>
                <input type="text" id="building" name="building" value="${result['building']}">
            </li>
            <li>
                <label for="tel">電話：</label>
                <input type="text" id="tel" name="tel" value="${result['tel']}">
            </li>
            <li>
                <label for="mail">メール：</label>
                <input type="text" id="email" name="email" value="${result['email']}">
            </li>
        </ul>
        <button id="user_edit_submit">変更</button>
        <button type="button" class="white" id="user_edit_cancel">キャンセル</button>
    `;
    document.getElementById('user_info_edit').innerHTML = formItems;
    document.getElementById('user_info_edit_modal').style.display = 'block';
    document.getElementById('user_edit_cancel').addEventListener('click',userInfoEditModalClose);
    userInfoEdit();
}
function userInfoEditModalClose(){
    document.getElementById('user_info_edit_modal').style.display = 'none';
}

function userInfoEdit(){
    document.getElementById('user_info_edit').addEventListener('submit', async (event) => {
        event.preventDefault();
    
        const form = event.target;
        const formData = new FormData(form);
    
        const response = await fetch('/system/user/cart/detaild-address-edit.php', {
            method: 'POST',
            body: formData
        });
    
        const data = await response.json();
        if(data.success){
            window.location.reload();
        }else{
            alert(data.message);
            window.location.reload();
        }
    });
}

document.getElementById('payment-form-open').addEventListener('click',()=>{
    document.getElementById('add-payment-wrap').style.display = 'block';
})
document.getElementById('payment-form-cancel').addEventListener('click',()=>{
    document.getElementById('add-payment-wrap').style.display = 'none';
})

// Stripe
async function getCustomerCard() {
	try {
		const req = await fetch('/system/user/cart/get-saved-cards-api.php');
        const res = await req.json();
        if(res.success){
            const cards = res.data;
            const wrap = document.getElementById('card-select');
            wrap.innerHTML = '';
    
            if (Array.isArray(cards) && cards.length !== 0) {
                let index = 1;
                cards.forEach(card => {
                    const label = document.createElement('label');
                    label.classList.add('credit-card-item');
                    const labelFor = 'credit-card-item-' + index;
                    label.setAttribute('for', labelFor);
    
                    const brand = card.card?.brand?.toUpperCase() ?? 'CARD';
                    const last4 = card.card?.last4 ?? '****';
                    const expMonth = card.card?.exp_month ?? '--';
                    const expYear = card.card?.exp_year ?? '--';
    
                    label.innerHTML = `
                        <span class="delete">削除</span>
                        <input type="radio" name="payment_method" id="credit-card-item-${index}" value="${card.id}" checked="checked">
                        <p>${brand} **** ${last4}</p>
                        <p>使用期限：${expMonth}/${expYear}</p>
                    `;
                    wrap.appendChild(label);
                    index++;
                });
                // 削除イベント
                const deletes = document.querySelectorAll('.delete');
                deletes.forEach((item) => {
                    item.addEventListener('click', cardDelete);
                })
            } else {
                const label = document.createElement('label');
                label.innerText = '有効なカードが登録されていません。';
                wrap.appendChild(label);
            }
        }
	} catch (error) {
		console.error('カード情報の取得エラー:', error);
		const wrap = document.getElementById('card-select');
		wrap.innerHTML = `<label>カード情報の取得に失敗しました：${error.message}</label>`;
	}
}

async function cardDelete(event){
    try {
        const paymentMethod = event.target.nextElementSibling.value;
		const res = await fetch('/system/user/cart/card-delete-api.php', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: new URLSearchParams({ payment_method_id: paymentMethod })
		});

		const result = await res.json();

		if (!res.ok) {
			throw new Error(result.error ?? 'カード削除に失敗しました');
		}
		location.reload();
	} catch (error) {
		alert('カード削除エラー');
	}
}
